module.exports = __webpack_public_path__ + "img/BarbarianFury.1034e0f5.png";